var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28.8,
    viewBox: "0 0 36 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-web",
    "data-name": "Icon material-web",
    d: "M35.4,6H6.6A3.6,3.6,0,0,0,3.018,9.6L3,31.2a3.611,3.611,0,0,0,3.6,3.6H35.4A3.611,3.611,0,0,0,39,31.2V9.6A3.611,3.611,0,0,0,35.4,6Zm-9,25.2H6.6V24H26.4Zm0-9H6.6V15H26.4Zm9,9H28.2V15h7.2Z",
    transform: "translate(-3 -6)",
    fill: "#74ad85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.675eddf2.svg";
export { ForwardRef as ReactComponent };